/**
 * Categorías de auxiliar con tratamiento especial en la UI.
 *
 * Tabla `categorias`:
 *   1 AA · 2 A · 3 B · 4 D (Le hicimos la cruz) · 5 NA (No activa) · 6 P (En prueba)
 *
 * - D  (4): se oculta por completo, no llega desde el backend.
 * - NA (5): sí se lista, pero en plomo y sin poder seleccionarse.
 */

export const CATEGORIA_D_ID = 4;
export const CATEGORIA_NA_ID = 5;

/** true si el id de categoría corresponde a NA (No activa). */
export const esCategoriaNoActiva = (id) => Number(id) === CATEGORIA_NA_ID;

/**
 * true si el auxiliar tiene categoría NA.
 * Comprueba `categoriaID` y también `des_categoria` porque según el endpoint
 * llega uno, el otro, o ambos.
 */
export const esAuxiliarNoActivo = (auxiliar) => (
    esCategoriaNoActiva(auxiliar?.categoriaID)
    || String(auxiliar?.des_categoria || "").trim().toUpperCase() === "NA"
);

export const ETIQUETA_NO_ACTIVA = "No activa";
